import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AccountService } from '../../../../../services/account/account.service';

@Component({
  selector: 'app-event-setup',
  templateUrl: './event-setup.component.html',
  styleUrls: ['./event-setup.component.css']
})
export class EventSetupComponent implements OnInit {

  // Whether to display the event setup navbar. We hide the navbar when creating
  // or editing an event type.
  public displayNav = true;

  constructor(
    public accountService: AccountService,
    public router: Router
  ) {}

  ngOnInit() {
    this.displayNav = (
      this.router.url.includes('/event-types') ||
      this.router.url.includes('/discounts') ||
      this.router.url.includes('/categories') ||
      this.router.url.includes('/voucher-packs')
    );

    // Update displayNav when routing occurs downstream of this component.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.displayNav = (
          event.urlAfterRedirects.includes('/event-types') ||
          event.urlAfterRedirects.includes('/discounts') ||
          event.urlAfterRedirects.includes('/categories') ||
          event.urlAfterRedirects.includes('/voucher-packs')
        );
      }
    });
  }

}
